import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1080p_Series/Network/ONVIF/SuccessBox';
import ONVIFTable from 'components/Web_User_Interface/1080p_Series/Network/ONVIF/onvifTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  SuccessBox,
  ONVIFTable,
  BreadCrumbs,
  SEOHelmet,
  React
};